import * as z from "zod";

export const getRecoverSettings = {
  name: "getRecoverSettings" as const,
  input: z.object({}),
  output: z.object({ brandName: z.string().nullable() }).nullable(),
};
